import React from 'react'
import Grid from '@material-ui/core/Grid'
import NavLink from 'Components/NavLink'

import User from 'EurestoClass/User'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import Bus from 'EurestoClass/Bus'

const interfacesAvailable = [3011, 3040, 3001, 3061]

export default (class extends React.Component {

  constructor(props) {
    super(props)
    const index = this.configuration[props.path] && this.configuration[props.path] !== true && this.configuration[props.path].findIndex(page => page.autorisation !== false) || -1;
    this.state = {
      UserTabSelected: index > -1 && this.configuration[props.path][index].id || index
    }
  }


  configuration = {
    crm: [
      {
        nom: 'Critère',
      },
      {
        nom: 'Onglet',
      },
      {
        nom: 'Critères => Onglets',
      },
      {
        nom: 'Civilité',
      },
      {
        nom: 'Qualité',
      },
      {
        nom: 'Relation',
      },
      {
        nom: 'Type client',
      },
      {
        nom: 'Motif archive',
      }
    ],
    gestion: [
      {
        nom: 'Rubrique',
      },
      {
        nom: 'Famille',
      },
      {
        nom: 'Critère',
      },
      {
        nom: 'Onglet',
      },
    ],
    etablissement: [
      {
        nom: 'Utilisateur',
        id: 1
      },
      {
        nom: 'Etablissements',
        autorisation: User.TypeAccess.get(Constants.access.GROUPE),
        id: 2
      },
      {
        nom: 'Profil',
        autorisation: !User.TypeAccess.get(Constants.access.GROUPE),
        id: 3
      },
      {
        nom: 'Groupe Utilisateur',
        autorisation: User.TypeAccess.get(Constants.access.EURESTO),
        id: 4
      },
    ],
    interface: (Data.list(Constants.module.COMMUN, Constants.donnee.option) || [])
      .filter(option => option.id > 3000 && option.id < 3999 && EurestoOption(option.id) && interfacesAvailable.indexOf(option.id) !== -1),
    restaurant: [
      {
        nom: 'Planning'
      },
      {
        nom: 'Restaurant',
        autorisation: (User.User.get().type === 1 || User.User.get().profil_id === 4 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1352)))
      },
      {
        nom: 'Motif Annulation',
        autorisation: (User.User.get().type === 1 || User.User.get().profil_id === 4 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1352)))
      },
      {
        nom: 'Motif Refus',
        autorisation: (User.User.get().type === 1 || User.User.get().profil_id === 4 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1352)))
      },
      {
        nom: 'Message',
        autorisation: (User.User.get().type === 1 || User.User.get().profil_id === 4 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1352)))
      },
      {
        nom: 'Configuration',
        autorisation: (User.User.get().type === 1 || User.User.get().profil_id === 4 || (!User.User.get().profil_id && EurestoAllowFonction(3, 1352)))
      },
      // {
      //   nom: 'Gestion Table',
      //   autorisation: EurestoOption(Constants.options[Constants.methods.RESTAURANT].TABLE.id),
      // },
      // {
      //   nom: 'Carcasse',
      //   autorisation: EurestoOption(Constants.options[Constants.methods.RESTAURANT].TABLE.id),
      // },
      /*{
        nom: 'Configuration'
      },*/
    ],
    hotel: [
      {
        nom: 'Fiche de Stock'
      },
      {
        nom: 'Tarif'
      },
      {
        nom: 'Origine'
      },
      {
        nom: 'Segmentation'
      },
      {
        nom: 'Planning'
      },
      {
        nom: 'Grille Tarifaire'
      },
    ],
    sdd: [
      {
        nom: 'Flag'
      },
      {
        nom: 'Classeur'
      },
      {
        nom: 'Messagerie',
        autorisation: User.TypeAccess.get(Constants.access.EURESTO)
      },
    ],
    pedagogie: [
      {
        nom: 'Formation'
      },
      {
        nom: 'Classe'
      },
      {
        nom: 'Élève'
      },
      {
        nom: 'Gestion des classes'
      },
    ],
    facturation: [
      {
        nom: 'Type Point Vente',
      },
      {
        nom: 'Point Vente',
      },
      {
        nom: 'Remise',
      },
      {
        nom: 'Offert',
      },
      {
        nom: 'Type de Marque',
      },
      {
        nom: 'Marque Catégorie',
      },
      {
        nom: 'Marque Indice',
      },
      {
        nom: 'Mode de Vente',
      },
      {
        nom: 'Catégorie Pax',
      },
      {
        nom: 'Regroupement de Taxe',
      },
      {
        nom: 'Mode d\'Encaissement',
      },
    ],
  }

  handlePage = (id) => _ => {
    this.setState({
      UserTabSelected: id
    }, _ => {
      Bus.$emit('donnees_annexes_' + this.props.path, id)
    })
  }

  render() {
    return (
      <Grid container className={'react-sanfona-item-body-wrapper'} spacing={0}
        style={{
          margin: 0,
          padding: 0,
          position: 'relative',
          borderLeft: '2px solid ' + EurestoColor('EurestoSecondary')
        }}>
        {
          this.configuration[this.props.path].filter(page => page.autorisation !== false).map((page) => {
            const i = this.configuration[this.props.path].findIndex(p => (p.libelle || p.nom) === (page.libelle || page.nom))
            return <Grid container wrap={'nowrap'} justify={'center'} alignItems={'center'} alignContent={'center'}
              spacing={0}>
              {/*<Grid className={(page.id || i) === this.state.UserTabSelected && 'EurestoSecondary' || 'EurestoText'}
                    item style={{ margin: 5, padding: 2.5, borderRadius: '50%' }}/>*/}
              <Grid item xs style={{ margin: 0, padding: 0, position: 'relative' }}>
                <Grid container direction={'column'} alignItems={'stretch'} justify={"center"} alignContent={"center"} spacing={0}
                  style={{ margin: 0, padding: 0, position: 'relative' }}>
                  <NavLink
                    style={{ lineHeight: 1, borderTopRightRadius: 5, borderBottomRightRadius: 5 }}
                    onClick={this.handlePage(page.id || i)}
                    className={(page.icon || '') + 'ssMenu menu-item cursor-pointer ' + ((page.id || i) === this.state.UserTabSelected && 'page-layout__nav-item--active' || '')}>
                    {(page.id || i) === this.state.UserTabSelected && <i style={{ fontSize: 10, position: 'absolute', left: 0, top: 10 }} className={'ei-commun_chevron_right EurestoSecondary--text'} />}
                    <span style={{ padding: '0 5px' }}>
                      {page.libelle || page.nom}
                    </span>
                  </NavLink>
                </Grid>
              </Grid>
            </Grid>
          }
          )
        }
      </Grid>
    )
  }

})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/Menu/index.js